export default {
  giftCards: [],
}
